import { useState, useEffect, useContext } from 'react';
import { useForm } from "react-hook-form";
import { Button, Form, Notification } from 'react-bulma-components';
import {Link} from "react-router-dom";
import { SessionContext } from '../SessionContext';
import ActivationInfo from './ActivationInfo';

export default function Level() {

    const [isLoggedIn, setIsLoggedIn] = useContext(SessionContext);
    const [isLoaded, setIsLoaded] = useState(false);
    const [item, setItem] = useState();
    
    const [riddleNumber, setRiddleNumber] = useState('');
    const [inputType, setInputType] = useState('text');
    const [msg, setMsg] = useState('Ładuję...');
    const [msgActivation, setMsgActivation] = useState('');
    const [hints, setHints] = useState([]);
    const [newHints, setNewHints] = useState([]);
    const [hideHintBtn, setHideHintBtn] = useState('');
    const [hintBtnContent, setHintBtnContent] = useState('Odkryj wskazówkę (-2 pkt)');
    const [hintDisabled, setHintDisabled] = useState(false);


    var responseOk = false;
    var responseStatus = null;
    
    useEffect(() => {
    fetch('https://studiotworzenia.pl/riddle.php', {
        crossDomain:true,
        method: 'GET',
        headers: {'Cache-Control': 'no-store', 'Auth-Code': 'Bearer '+localStorage.getItem('user_code')},
    })
    .then((response) => {
        responseOk = response.ok;
        responseStatus = response.status;
        return response.json();
    })
    .then((result) => {
        if(responseOk){
            setIsLoggedIn(true);
            if(responseStatus==202){
                setMsg(<Notification color="warning" ><h1 className="is-size-1">🚫</h1>Ukończyłeś grę w podejrzanie krótkim czasie... Zostajesz wykluczony z rankingu. Jeżeli nie oszukiwałeś, skontaktuj się ze stoiskiem JohnnyBros, w celu wyjaśnienia sprawy.</Notification>);
                setHints([]);
                setIsLoaded(false);
            }
            else if(responseStatus==201){
                setItem(null);
                setMsg(<>
                <p>{result.description}</p>
                <p><strong><span className="has-text-success mb-2">Twój wynik to </span>{result.points} pkt.</strong></p>
                </>);
                if( ! result.is_active)
                    setMsgActivation(<ActivationInfo email={result.email}/>);
                setHints([]);
                setIsLoaded(false);

            }
            else{
                setInputType(result.type);
                setRiddleNumber(result.number);
                setItem(result.description);
                setMsg('');
                setHints(result.hints);
                setIsLoaded(true);
            }

            if(result.hintsTotal >= 3)
                setHideHintBtn('is-hidden');
            
        }
        else{
            setMsg(<Notification color="danger" >{result.message}</Notification>);
        }
    });
    }, []);


    const refresh = () => {
        window.location.reload(false);
    }



    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    const sendAns = (data) => {

        var formData = new FormData();
        formData.append('myAns', data.myAns);

        fetch('https://studiotworzenia.pl/ans.php', {
            crossDomain:true,
            method: 'POST',
            headers: {'Cache-Control': 'no-store', 'Auth-Code': 'Bearer '+localStorage.getItem('user_code')},
            body: formData,
        })
        .then((response) => {
            responseOk = response.ok;
            return response.json();
        })
        .then((result) => {
            if(responseOk){
                if(result.hasOwnProperty('success_text')){
                  setIsLoaded(false);
                  setMsg(<Notification color="success" >👍 {result.success_text}<br/><button className="button mt-2" onClick={refresh}>Kliknij, aby przejść dalej</button></Notification>);
                }
                else{
                  setIsLoaded(false);
                  setMsg(<Notification color="black" >😅 Ups. Błędna odpowiedź.<br/><button className="button mt-2" onClick={refresh}>Spróbuj ponownie</button></Notification>);
                }
            }
            else{
                setMsg(<Notification color="danger" >{result.message}</Notification>);
            }
        });
    }



    const handleHint = (event) => {
        
        setHintBtnContent('Pobieram podpowiedź...');
        setHintDisabled(true);

        fetch('https://studiotworzenia.pl/hint.php', {
        crossDomain:true,
        method: 'GET',
        headers: {'Cache-Control': 'no-store', 'Content-Type':'application/json', 'Auth-Code': 'Bearer '+localStorage.getItem('user_code')},
        })
        .then((response) => {
            responseOk = response.ok;
            return response.json();
        })
        .then((result) => {
            if(responseOk){
                setNewHints([...newHints, result.hint]);

                if(result.hintsTotal >= 3)
                    setHideHintBtn('is-hidden');

                setHintBtnContent('Odkryj wskazówkę (-2 pkt)');
                setHintDisabled(false);

            }
            else{
                setMsg(<Notification color="danger" >{result.message}</Notification>);
            }
        });
    }

    if(isLoaded)
    return (
        <>
        <h3 className="title">ZAGADKA {riddleNumber}/11</h3>
        <p className="mb-2" dangerouslySetInnerHTML={{__html: item}}></p>
        
        <div className="mb-5">
        <form onSubmit={handleSubmit(sendAns)}>
            <input className="input" type={inputType} maxLength="24"  {...register("myAns", { required: "Podaj odpowiedź!" })} />
            <div className="mt-4 mb-2"><button type="submit" className="button is-primary">Wyślij odpowiedź</button></div>
            {errors.myAns && <p className="has-text-danger">{errors.myAns.message}</p>}
        </form>
        </div>

        {msg}
        
        {hints?.map((hint,index) => (
        <p key={index} className="mb-3"><strong>Podpowiedź:</strong> {hint}</p>
        ))}

        {newHints?.map((hint,index) => (
        <p  key={index} className="mb-3"><strong>Podpowiedź:</strong> {hint}</p>
        ))}
        

        <div className={"mb-2 "+hideHintBtn}><button className="button is-info" disabled={hintDisabled} onClick={handleHint}>{hintBtnContent}</button></div>
        
        </>
        
    );
    else
    return(
        <>
        {msg}
        {msgActivation}
        </>
    );
}